<!-- Menu header -->
<div class="navbar-header">
  <ul class="nav navbar-nav flex-row">
    <li class="nav-item mr-auto">
      <!-- App Branding -->
      <a class="navbar-brand" [routerLink]="['/']">
        <span class="brand-logo">
          <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" />
        </span>
        <h2 class="brand-text mb-0">{{ coreConfig.app.appCode }}</h2>
      </a>
    </li>
  </ul>
</div>
<!--/ Menu header -->

<!-- Navbar shadow -->
<div class="shadow-bottom" [ngClass]="{ 'd-block': isScrolled }"></div>

<!-- Main menu -->
<div class="main-menu-content" [perfectScrollbar] (scroll)="onSidebarScroll()">
  <ul class="navigation navigation-main" layout="vertical" core-menu></ul>
</div>
<!--/ Main menu -->

<!-- Quote of the week -->
<div class="main-menu-quote">
  <div class="main-menu-quote-label">Quote of the week</div>
  <p class="main-menu-quote-text">"Talent gets attention, but consistent hard work earns trust."</p>
</div>
<!--/ Quote of the week -->

<!-- Sidebar footer -->
<div class="main-menu-footer">
  <a class="d-flex align-items-center py-1 px-1" [routerLink]="['/application/help-support']">
    <span data-feather="help-circle" class="mr-1"></span>
    <span>Help and Support</span>
  </a>
  <a class="d-flex align-items-center py-1 px-1" href="javascript:void(0)" (click)="logout()">
    <span data-feather="log-out" class="mr-1"></span>
    <span>Logout</span>
  </a>
</div>
<!--/ Sidebar footer -->
